import { Schema, SchemaSettings } from '@orbit/data'
import { KC } from '@/http/utils'
import { PatientWithEventsEvent } from '@/jsonapi/PatientWithEvents'
import { DataPoint, InhalerCompliance, InhalerProduct } from '@/jsonapi/CommonTypes'

enum ModelTypes {
  SiteReadings = 'site-reading',
}

enum ModelTypeNames {
  SiteReadings = 'siteReading',
}

export interface GenericReading {
  siteId?: string
  matchedPatientId?: string
  devicePatientId?: string
  operatorId?: string
  gatewayId?: string
  serialNumber?: string
  value: number
  timestamp: number
}

export interface SiteReadings {
  id: string
  siteId: string
  glucometerReadings: GenericReading[]
  vitalSignReadings: GenericReading[]
  startTimestamp: number | null | undefined
  endTimestamp: number | null | undefined
  resultStartTimestamp: number | null | undefined
  resultEndTimestamp: number | null | undefined
}

export interface GetSiteReadingsByIdDto {
  siteId: string
  startTimestamp: number
  endTimestamp: number
}

export interface SiteReadingsSchema {
  id: string
  attributes: SiteReadings
}

const schemaDefinition: SchemaSettings = {
  models: {
    [ModelTypeNames.SiteReadings]: {
      attributes: {
        id: { type: 'string' },
        siteId: { type: 'string' },
        glucometerReadings: { type: 'array' },
        vitalSignReadings: { type: 'array' },
        starttimestamp: { type: 'number' },
        endtimestamp: { type: 'number' },
        resultStartTimestamp: { type: 'number' },
        resultEndTimestamp: { type: 'number' },
      },
    },
  },
}
export interface GetPatientWithSummaryReportsByIdDto {
  patientId: string
  startTimestamp: number
  endTimestamp: number
}

export async function getSiteReadingsById(params: { siteId: string; startTimestamp: number; endTimestamp: number }) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  const queryExpression = q => {
    const expression = q.findRecords(ModelTypes.SiteReadings)
    return expression.filter(
      { attribute: 'id', value: params.siteId },
      { attribute: 'starttimestamp', value: params.startTimestamp },
      { attribute: 'endtimestamp', value: params.endTimestamp }
    )
  }

  return remote.query(queryExpression).catch(e => {
    console.log('fetch failed in site readings' + JSON.stringify(e))
  })
}
